var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeeting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 4.5H21.25C22.249 4.5 23 5.2488 23 6.10227V17.3144C23 18.1679 22.249 18.9167 21.25 18.9167H3.25C2.25098 18.9167 1.5 18.1679 1.5 17.3144V6.10227C1.5 5.2488 2.25098 4.5 3.25 4.5Z",
    stroke: "#283299"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 11C14.1307 11 15.25 9.88071 15.25 8.5C15.25 7.11929 14.1307 6 12.75 6C11.3693 6 10.25 7.11929 10.25 8.5C10.25 9.88071 11.3693 11 12.75 11Z",
    fill: "#283299"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8875 17.4762V14.9175C16.8331 14.3501 16.5699 13.828 16.1544 13.4634C15.7389 13.0989 15.2044 12.9211 14.666 12.9684H10.2215C9.68309 12.9211 9.14861 13.0989 8.73312 13.4634C8.31763 13.828 8.05437 14.3501 8 14.9175V17.4762",
    stroke: "#283299",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeeting);
export default __webpack_public_path__ + "static/media/meeting.73cef2258761115379ae0e6a9501357f.svg";
export { ForwardRef as ReactComponent };